import Dropdown from "../Dropdown"
import { withCustomData } from "../withData"
import { Token } from "../../useAuthorizationCodeFlow"

function getFacilityURL(): Promise<string> {
    return new Promise<string>((resolve) => {
        const waitForAccessToken = () => {
            const token = new Token(localStorage.getItem("chargebook_access_token")!)

            if (token.tenantId() === -1) {
                setTimeout(waitForAccessToken, 200)
            } else {
                resolve(`/api/${token.tenantId()}/facility`)
            }
        }

        waitForAccessToken()
    })
}

export default withCustomData(getFacilityURL(), item => {
    return {
        value: item.id
        , name: item.attributes.name
    }
})(Dropdown)